__turbopack_context__.v({
  "className": "interfont_c6b11be9-module__JXFo1W__className",
  "variable": "interfont_c6b11be9-module__JXFo1W__variable",
});
